import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { Cushion, FlexContainer, Grid, Shadow, Rectangle, Typography } from '@pitchero/react-ui';
import FixtureStatistics from '../stats/fixture-statistics';
import { Trans } from '../../../lib/i18n';

const ProfileHeaderStats = ({ name, featured, fixturesSummary }) => {
  if (isEmpty(featured) && isEmpty(fixturesSummary)) {
    return (
      <Rectangle
        fill="mercury"
        radius="rounded"
        style={{
          height: 140,
          gridRowStart: 'fixturesSummary',
          gridColumnStart: 'stats',
          gridColumnEnd: 'fixturesSummary',
          msGridColumn: 2,
          msGridColumnSpace: 2,
        }}
      >
        <Cushion horizontal="medium">
          <FlexContainer alignItems="center" justifyContent="center">
            <Typography preset="subtitle--large" color="dustygrey" align="center" component="div">
              <Trans i18nKey="profile_no_appearances" values={{ name }}>
                {`Looks like ${name} didn’t play this season`}
              </Trans>
            </Typography>
          </FlexContainer>
        </Cushion>
      </Rectangle>
    );
  }

  return (
    <>
      {!isEmpty(featured) && (
        <Shadow style={{ gridArea: 'stats' }}>
          <Rectangle fill="white" radius="rounded">
            <Cushion all="medium" responsive={[{ minWidth: 'tab', props: { all: 'large' } }]}>
              <Grid
                className="grid-profile-header__stats"
                columns={`repeat(${featured.length}, minmax(0, 1fr))`}
                justifyItems="center"
                columnGap="medium"
                rowGap="small"
                style={{
                  msGridColumns: featured.map(() => '1fr').join(' '),
                }}
              >
                {featured.map((stat) => (
                  <FlexContainer flexDirection="column" justifyContent="space-between">
                    <Typography
                      key={`${stat.label}-value`}
                      preset="title"
                      color="black"
                      component="div"
                      align="center"
                    >
                      {stat.value}
                    </Typography>
                    <Cushion vertical="xsmall">
                      <Typography
                        key={`${stat.label}-label`}
                        preset="tag--large"
                        color="silver"
                        component="div"
                        align="center"
                      >
                        {stat.label}
                      </Typography>
                    </Cushion>
                    <Cushion key={`${stat.label}-bar`} top="small" horizontal="25%" component="div">
                      <Rectangle fill="gold" radius="rounded" style={{ height: 4 }} />
                    </Cushion>
                  </FlexContainer>
                ))}
              </Grid>
            </Cushion>
          </Rectangle>
        </Shadow>
      )}
      {get(fixturesSummary, 'played', 0) > 0 && (
        <FixtureStatistics
          className="grid-profile-header__fixtures"
          {...fixturesSummary}
          style={{ gridArea: 'fixturesSummary' }}
        />
      )}
    </>
  );
};

ProfileHeaderStats.defaultProps = {
  featured: [],
  fixturesSummary: null,
};

ProfileHeaderStats.propTypes = {
  name: PropTypes.string.isRequired,
  featured: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  fixturesSummary: PropTypes.shape({
    played: PropTypes.number.isRequired,
    W: PropTypes.number.isRequired,
    L: PropTypes.number.isRequired,
    D: PropTypes.number.isRequired,
  }),
};

export default ProfileHeaderStats;
